import { Dispatch } from 'react';

import { SuSyApi } from '../../api/susyApi';
import {
    EmailTemplateAction,
    EmailTemplatesActionType,
} from '../actionTypes/emailTemplates';

import { IEmailTemplate } from 'susy-common/models';

export const getAllEmailTemplates =
    () => async (dispatch: Dispatch<EmailTemplateAction>) => {
        const response = await SuSyApi.get('/emailTemplate');
        dispatch({
            type: EmailTemplatesActionType.GET_ALL_EMAIL_TEMPLATES,
            payload: response.data,
        });
    };

export const updateEmailTemplate =
    (emailTemplate: IEmailTemplate) =>
    async (dispatch: Dispatch<EmailTemplateAction>) => {
        const response = await SuSyApi.put(
            `/emailTemplate/${emailTemplate._id}`,
            emailTemplate
        );
        dispatch({
            type: EmailTemplatesActionType.UPDATE_EMAIL_TEMPLATE,
            payload: response.data,
        });
    };
